<template>
    <div class="affirmKmCom">
        <div class="titleBox">
            <span>确认公里数</span>
            <van-icon name="cross" size="20" class="closeIcon" @click="close"/>
        </div>
        <div class="formData">
			<div class="formLi">
				<div class="lableBox">
					<span class="lableText">订单号</span>
				</div>
				<div class="valueBox">
					<span class="valueText">{{ orderInfo.no }}</span>
				</div>
			</div>
			<div class="formLi">
				<div class="lableBox">
					<span class="lableText">车牌号</span>
				</div>
				<div class="valueBox">
					<span class="valueText">{{ orderInfo.car_no }}</span>
				</div>
			</div>
			<div class="formLi">
				<div class="lableBox">
					<span class="lableText">救援类型</span>
				</div>
				<div class="valueBox">
					<span class="valueText">{{ orderInfo.type | filterType }}</span>
				</div>
			</div>
			<div class="formLi">
				<div class="lableBox">
					<span class="lableText">背车里程</span>
				</div>
				<div class="valueBox">
					<span class="valueText">{{ orderInfo.get_distance }}km</span>
				</div>
			</div>
		</div>
        
        <div class="formData" v-if="faultReasonData.length">
			<!-- 故障原因 -->
			<div class="title">
				<span class="isNeed">*</span>
				<span class='titleName'>故障原因</span>
			</div>
			<scroll-view scroll-y :show-scrollbar='false' class="faultData">
				<div class="faultLi" v-for="(item, index) in faultReasonData" :key="index" @click="faultReasonInfo = item">
					<span class="faultName">{{ item.name }}</span>
					<img :src="faultReasonInfo.id == item.id ? radio_y : radio_n" alt="" class="icon" />
				</div>
			</scroll-view>
		</div>

		<div class="footerBox">
			<div class="btn leftBtn" @click="openComplaint">
				<span class="leftText">申 诉</span>
			</div>
			<div class="btn rightBtn" @click="affirmKm">
				<span class="rightText">确 认</span>
			</div>
		</div>
        
        <van-popup v-model="complaintVsi" position="bottom" get-container="#app" class="editKmCom">
            <div class="titleBox">
                <span>修改背车里程</span>
                <van-icon name="cross" size="20" class="closeIcon" @click="complaintVsi = false"/>
            </div>
            <div class="tipsText">背车里程需按实际里程填写，里程造假将不予结算！</div>
            <div class="formData">
                <div class="formLi">
                    <div class="lableBox">
                        <span class="lableText">订单号</span>
                    </div>
                    <div class="valueBox">
                        <span class="valueText">{{ orderInfo.no }}</span>
                    </div>
                </div>
                <div class="formLi">
                    <div class="lableBox">
                        <span class="lableText">车牌号</span>
                    </div>
                    <div class="valueBox">
                        <span class="valueText">{{ orderInfo.car_no }}</span>
                    </div>
                </div>
                <div class="formLi">
                    <div class="lableBox">
                        <span class="lableText">救援类型</span>
                    </div>
                    <div class="valueBox">
                        <span class="valueText">{{ orderInfo.type | filterType }}</span>
                    </div>
                </div>
                <div class="formLi">
                    <div class="lableBox">
                        <span class="lableText">背车里程</span>
                    </div>
                    <div class="valueBox">
                        <span class="valueText">{{ orderInfo.get_distance }}km</span>
                    </div>
                </div>
                <div class="editFormLi">
                    <div class="lableBox">
                        <span class="bitian">*</span>
                        <span class="lableText">实际背车里程（km）</span>
                    </div>
                    <div class="valueBox">
                        <van-field class="inputBox" v-model="formData.get_distance" type="number" placeholder="请输入实际背车里程">
                            <template #extra>
                                <span>km</span>
                            </template>
                        </van-field>
                    </div>
                </div>
                <div class="editFormLi">
                    <div class="lableBox">
                        <span class="bitian">*</span>
                        <span class="lableText">上传行驶轨迹图</span>
                    </div>
                    <div class="otherImgs imageBox">
                        <van-uploader 
                            upload-text='行驶轨迹'
                            :after-read="uploadImg"
                            :before-delete="(file) => delImg(file, index)"
                            result-type='file'
                            v-model="imgList"/>
                    </div>
                </div>
            </div>
            
            <div class="affirmBtn" @click="submitEditKm">
                确认提交
            </div>
        </van-popup>
    </div>
</template>

<script>
import { generateCanvasImg, initWatermarkConfigData } from '@/utils/uploadOSS';
import { orderFaultReasonOptions } from '@/apis/checkList';
export default {
    props: {
        finishData: {
            type: Object | null,
            default: null
        },
        orderInfo: {
            type: Object | null,
            default: null
        },
        uploadParams: {
            type: Object | null,
            default: null
        },
    },
    data(){
        return {
            complaintVsi: false,        //申诉修改里程
            formData: {
                act: '',			//空 确认 complaint 申诉
                get_distance: '',	//背车里程
                picture: '',		//导航图片
            },
            imgList: [],
            radio_n: require('@/assets/join/radio_n.png'),
            radio_y: require('@/assets/join/radio_y.png'),
            faultReasonData: [],
            faultReasonInfo: {
                id: '',
                name: ''
            }
        }
    },
    mounted(){
        this.getFaultReasonOptions()
    },
    methods: {
        // 获取订单可选故障原因
        getFaultReasonOptions(){
            let params = {
                order_id: this.orderInfo.id
            }
            this.$toast.loading({
                message: '加载中...',
                forbidClick: true,
                overlay: true,
                duration: 0,
                loadingType: 'spinner',
            });
            orderFaultReasonOptions(params).then((res)=>{
                this.faultReasonData = res.data.data
            }).finally(()=>{
                this.$toast.clear()
            })
        },
        close(){
            this.$emit('close')
        },
        // 申诉
        openComplaint(){
            if(this.faultReasonData.length && (!this.faultReasonInfo || !this.faultReasonInfo.id)){
                this.$notify({ 
                    type: 'danger',
                    message: '请选择故障原因！'
                });
                return
            }
            this.complaintVsi = true
        },
        uploadImg(file){
            let that = this
            let reader = new FileReader();
            reader.readAsDataURL(file.file);

            let configData = initWatermarkConfigData(this.uploadParams);       //水印配置文件
            file.status = 'uploading';
            file.message = '上传中...';
            reader.onload = function(theFile) {
                let image = new Image();
                image.src = theFile.target.result;
                image.onload = function() {
                    let data = {
                        img: image,
                        w: this.width,
                        h: this.height,
                        configData,
                        id: that.orderInfo.id
                    }
                    generateCanvasImg(data).then((url)=>{
                        file.status = 'done';
                        file.message = '上传成功';
                        file.url = url;
                    }).catch((err)=>{
                        that.imgList.pop()
                        that.$notify({ 
                            type: 'danger',
                            message: 'OSS上传失败!'
                        });
                    })
                }
            }
        },
        delImg(file, index){
            this.imgList.splice(index, 1)
        },
        // 确认里程
        affirmKm(){
            if(this.faultReasonData.length && (!this.faultReasonInfo || !this.faultReasonInfo.id)){
                this.$notify({ 
                    type: 'danger',
                    message: '请选择故障原因！'
                });
                return
            }
            let data = JSON.parse(JSON.stringify(this.finishData))
            data.act = ''
			data['fault_reason'] = this.faultReasonInfo.name
            this.$emit('affirm', data)
        },
        // 提交修改后的里程
        submitEditKm(){
            if(!this.formData.get_distance || isNaN(Number(this.formData.get_distance))){
                this.$toast('请输入正确的背车里程！');
                return
            }
            if(!this.imgList.length){
                this.$toast('请上传行驶轨迹截图！');
                return
            }
            let photos = []
            this.imgList.forEach((e)=>{
                photos.push(e.url)
            })
            this.formData.picture = photos.toString()
            this.formData.act = 'complaint';
			this.formData['fault_reason'] = this.faultReasonInfo.name
            let data = Object.assign({}, this.finishData, this.formData)
            this.$emit('affirm', data)
        },
    }
}
</script>

<style lang="scss" scoped>
    .affirmKmCom{
        padding: 0 16px 20px;
        box-sizing: border-box;
        .closeIcon{
            position: absolute;
            top: 10px;
            right: 10px;
        }
        .titleBox{
            height: 44px;
            text-align: center;
            line-height: 44px;
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 5px;
        }
        .formData{
			background: #FAFAFA;
			border-radius: 5px;
			border: .5px solid #E4E4E4;
			padding: 12px 12px 0 12px;
            margin-bottom: 12px;
			.formLi{
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				margin-bottom: 12px;
				.lableBox{
					.lableText{
						line-height: 18px;
						font-weight: 400;
						font-size: 14px;
						color: #666666;
					}
				}
				.valueBox{
					.valueText{
						line-height: 18px;
						font-weight: 400;
						font-size: 14px;
						color: #000000;
					}
				}
			}
            .title{
				display: flex;
				flex-direction: row;
				align-items: center;
                margin-bottom: 6px;
				.isNeed{
					font-size: 14px;
					color: #f01c1c;
				}
				.titleName{
					font-size: 14px;
					color: #333333;
					font-weight: bold;
				}
			}
			.faultData{
				max-height: 450px;
				overflow-y: scroll;
				.faultLi{
					height: 30px;
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: space-between;
					.icon{
						width: 16px;
						height: 16px;
						margin-left: 8px;
					}
					.faultName{
						font-size: 14px;
						color: #333;
					}
				}
			}
		}
        .footerBox{
			margin-top: 25px;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			.btn{
				width: 135px;
				height: 40px;
				border-radius: 50px;
				display: flex;
				flex-direction: row;
				justify-content: center;
				align-items: center;
			}
			.leftBtn{
				background: var(--theme-btn);
			}
			.leftText{
				font-size: 15px;
				font-weight: 600;
				color: var(--theme-color);
			}
			.rightBtn{
				background: var(--theme-color);
			}
			.rightText{
				font-size: 15px;
				font-weight: 600;
				color: var(--theme-btn);
			}
		}
    }
    .editKmCom{
        .closeIcon{
            position: absolute;
            top: 10px;
            right: 10px;
        }
        .titleBox{
            height: 44px;
            text-align: center;
            line-height: 44px;
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 5px;
        }
        .tipsText{
            text-align: center;
            font-size: 13px;
            line-height: 20px;
            margin-bottom: 10px;
            color: #F01C1C;
        }
        .formData{
            height: 400px;
            padding: 12px;
            overflow-y: scroll;
            .formLi{
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				margin-bottom: 12px;
				.lableBox{
					.lableText{
						line-height: 18px;
						font-weight: 400;
						font-size: 14px;
						color: #666666;
					}
				}
				.valueBox{
					.valueText{
						line-height: 18px;
						font-weight: 400;
						font-size: 14px;
						color: #000000;
					}
				}
			}
            .editFormLi{
                margin-top: 24px;
				margin-bottom: 12px;
                .lableBox{
                    display: flex;
                    flex-direction: row;
                    .bitian{
                        line-height: 18px;
                        font-size: 14px;
                        color: #F01C1C;
                    }
                    .lableText{
                        line-height: 18px;
                        font-size: 14px;
                        color: #666666;
                    }
                }
                .inputBox{
                    width: 100%;
                    height: 40px;
                    border-radius: 5px;
                    border: .5px solid #E4E4E4;
                    display: flex;
                    align-items: center;
                    margin-top: 8px;
                }
                .otherImgs{
                    margin-top: 12px;
                    font-size: 14px;
                    border-radius: 4px;
                    box-sizing: border-box;
                }
            }
        }
        .affirmBtn{
            width: 350px;
            height: 40px;
            background: var(--theme-color);
            border-radius: 20px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            margin: 20px auto 16px;
            font-weight: 600;
            font-size: 16px;
            color: var(--theme-btn);
        }
    }
</style>